import { supabase } from '../supabase';

/**
 * Build fetch headers with the current Supabase session token.
 * Always includes Content-Type. Adds Authorization if a session exists.
 * Automatically refreshes the token if it's expired or about to expire
 * (within 60 seconds) so API calls don't fail with "invalid or expired token".
 */
export async function authHeaders() {
  let { data: { session } } = await supabase.auth.getSession();

  // If the token is expired or expires within 60 seconds, refresh it
  if (session?.expires_at && session.expires_at * 1000 - Date.now() < 60000) {
    const { data, error } = await supabase.auth.refreshSession();
    if (!error && data?.session) {
      session = data.session;
    }
  }

  const headers = { 'Content-Type': 'application/json' };
  if (session?.access_token) {
    headers['Authorization'] = `Bearer ${session.access_token}`;
  }
  return headers;
}
